export const breakpoints = {
    xxSmall: 480,
    xSmall: 576,
    small: 640,
    medium: 768,
    large: 1024,
    xLarge: 1280,
}
